/* eslint-disable camelcase */
import GiftCertificateSelector from 'components/pages/checkout/GiftCertificateSelector';
import Heading from 'components/text/Heading';
import LoadingIcon from 'assets/icons/Loading';
import Paragraph from 'components/text/Paragraph';
import Payment from 'components/pages/checkout/CheckoutView/Payment';
import PropTypes from 'prop-types';
import React from 'react';
import ThemeButton from 'components/buttons/ThemeButton';
import Wysiwyg from 'libs/wordpress/components/Wysiwyg';
import { above } from 'utils/mediaqueries';
import styled from 'libs/styled';
import { useGiftCertificateContext } from 'libs/GiftCertificate/GiftCertificateContext';

const Div = styled('div')``;

const IntroWrapper = styled('div')`
    ${above.lg} {
        width: calc(83.333% + 24px);
        max-width: 844px;
        padding: 0px 12px;
        margin-left: -12px;
    }
`;

const ContetnWrapper = styled('div')`
    ${above.lg} {
        width: calc(66% + 24px);
        max-width: 674px;
        padding: 0px 12px;
        margin-left: -12px;
    }
`;

const MainHeading = styled(Heading)`
    ${above.lg} {
        font-size: 56px;
    }
`;

const Preamble = styled(Paragraph)`
    font-size: 20px;
    line-height: 1.2;
`;

const StepButton = styled(ThemeButton)`
    width: 100%;
    font-size: 16px;
`;

const GiftCertificateContent = ({ data }) => {
    const { content, gift_certificate_setup: giftCertificate } = data;
    const { heading, preamble_paragraph: preamble, paragraph } = content;
    const {
        button_label_edit: buttonLabelEdit,
        button_label_procced: buttonLabelProcced,
        flexible_gift_certificate_placeholder: flexibleGiftCertPlaceholder,
        heading: certificateHeading,
        maximum_gift_certificate_value: maxValue,
        minimum_gift_certificate_value: minValue,
    } = giftCertificate;

    const {
        editSelectedGiftCertificate,
        giftCertCheckoutStep,
        giftCerts,
        onSelect,
        proceedToCheckout,
        readyToProceed,
        sectionLoading,
        selectedGiftCert,
    } = useGiftCertificateContext();

    return (
        <>
            <IntroWrapper>
                {heading?.text && (
                    <MainHeading as={heading.type} size="medium" mb="40px">
                        {heading.text}
                    </MainHeading>
                )}
                {preamble && (
                    <Div mb="40px">
                        <Wysiwyg data={preamble} textComponent={props => <Preamble {...props} />} />
                    </Div>
                )}
            </IntroWrapper>
            <ContetnWrapper>
                {paragraph && (
                    <Div mb="80px">
                        <Wysiwyg data={paragraph} textComponent={props => <Paragraph {...props} />} />
                    </Div>
                )}

                <Div display="flex" flexDirection="column" mb="40px">
                    {certificateHeading.text && (
                        <Heading size="small" as={certificateHeading.type} mb="40px">
                            {certificateHeading.text}
                        </Heading>
                    )}
                    {sectionLoading === 'giftCerts' ? (
                        <LoadingIcon alignSelf="center" />
                    ) : (
                        <GiftCertificateSelector
                            disabled={!!sectionLoading || giftCertCheckoutStep > 1}
                            flexibleGiftCertPlaceholder={flexibleGiftCertPlaceholder}
                            giftCertificates={giftCerts}
                            maxValue={maxValue}
                            minValue={minValue}
                            selectedId={selectedGiftCert?.id}
                            onSelect={onSelect}
                        />
                    )}
                </Div>

                <Div display="flex" flexDirection="column" mb="80px">
                    {giftCertCheckoutStep === 1 ? (
                        <StepButton
                            size="xxl"
                            disabled={!readyToProceed || sectionLoading === 'checkout'}
                            onClick={proceedToCheckout}
                        >
                            {buttonLabelProcced}
                        </StepButton>
                    ) : (
                        <StepButton size="xxl" onClick={editSelectedGiftCertificate}>
                            {buttonLabelEdit}
                        </StepButton>
                    )}
                    {sectionLoading === 'checkout' && <LoadingIcon mt="40px" alignSelf="center" />}
                </Div>

                {giftCertCheckoutStep === 2 ? (
                    <Payment displayShipping={false} paymentMethodId="adyen-drop-in" />
                ) : null}
            </ContetnWrapper>
        </>
    );
};

GiftCertificateContent.propTypes = {
    data: PropTypes.shape({
        content: PropTypes.object,
        gift_certificate_setup: PropTypes.object,
    }),
};

GiftCertificateContent.defaultProps = {
    data: {
        content: {},
        gift_certificate_setup: {},
    },
};

export default GiftCertificateContent;
